import {Injectable, OnDestroy} from '@angular/core';
import {fromEvent, Observable, Subscription} from 'rxjs';


@Injectable({providedIn: 'root'})
export class NetworkService implements OnDestroy {
  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;

  subscriptions: Subscription[] = [];

  online;
  isActive: boolean;

  constructor() {

    this.online = window.navigator.onLine;

    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');

    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      console.log('online');
      this.online = true;
    }));

    this.subscriptions.push(this.offlineEvent.subscribe(e => {
      console.log('offline');
      this.online = false;
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
